/**
 * Utility functions for the application.
 * This file contains helper functions for class name management using clsx and tailwind-merge.
 * The `cn` function combines multiple class names and merges Tailwind CSS classes efficiently.
 */

import { type ClassValue, clsx } from 'clsx';
import { twMerge } from 'tailwind-merge';

export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs));
}

export const getMeta = (name: string): string | null =>
  typeof document !== 'undefined'
    ? ((
        document.querySelector(`meta[name="${name}"]`) as HTMLMetaElement | null
      )?.content ?? null)
    : null;
